import { BUNDLED_STATIC_TEXT_TRANSLATIONS, FALLBACK_STATIC_TEXT_LANGUAGE, setStaticTextsI18n, STATIC_TEXTS_NAMESPACE } from '@dvinci/attract-studio-components'
import { createInstance, type i18n as I18nInstance, type Resource } from 'i18next'

/**
 * Die i18next-Instanz der Karriereseite – eine pro Laufzeit, also je einmal im Server-Prozess und
 * im Browser. Sie wird nie umgeschaltet: jeder Aufruf gibt seine Sprache explizit mit, damit
 * nebenläufige Requests in verschiedenen Sprachen sich nicht in die Quere kommen.
 *
 * Deutsch und Englisch bringt attract-studio-components mit, alle weiteren Sprachen werden mit
 * `addStaticTextTranslations` nachgereicht.
 */
const toResources = (): Resource =>
  Object.fromEntries(Object.entries(BUNDLED_STATIC_TEXT_TRANSLATIONS).map(([language, translations]) => [language, { [STATIC_TEXTS_NAMESPACE]: translations }]))

const createStaticTextsI18n = (): I18nInstance => {
  const instance = createInstance()

  instance.init({
    lng: FALLBACK_STATIC_TEXT_LANGUAGE,
    fallbackLng: FALLBACK_STATIC_TEXT_LANGUAGE,
    ns: [STATIC_TEXTS_NAMESPACE],
    defaultNS: STATIC_TEXTS_NAMESPACE,
    keySeparator: false,
    nsSeparator: false,
    interpolation: { escapeValue: false },
    resources: toResources()
  })

  setStaticTextsI18n(instance)

  return instance
}

export const staticTextsI18n = createStaticTextsI18n()

export const addStaticTextTranslations = (language: string, translations: Record<string, string>): void => {
  staticTextsI18n.addResourceBundle(language, STATIC_TEXTS_NAMESPACE, translations, true, true)
}
